module.exports = leafletGestureHandling;